import { render, staticRenderFns } from "./RecentOpportunities.vue?vue&type=template&id=f86717c8&"
import script from "./RecentOpportunities.vue?vue&type=script&lang=js&"
export * from "./RecentOpportunities.vue?vue&type=script&lang=js&"
import style0 from "./RecentOpportunities.vue?vue&type=style&index=0&id=f86717c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports